module.exports = __webpack_public_path__ + "img/CIMG1146.b5d7afdf.jpg";